import { mapActions } from "vuex";

export default  {
	created () {    
	   
	},
	methods: 
    {	
		...mapActions({			
			saveAll: 'crudStore/saveAll',
		}),
		async actualizarFtn()
		{
			try{

			}catch{

			}
		},
		async saveForm(event)
		{
			try{
				let savePost = false
				if(event.ftn!==undefined)
				{
					switch(event.ftn)
					{
						case 'tablePostGuardarFtn':
							// se abre el modal de afiliaciongrupal
							await this.updateGlobal({state: 'openModal/modal',    data: 
								{ value: true, title: 'Registrar Afiliación Grupal', modal: 'AfiliacionGrupal' } })
							return true
						break
						case 'afiliacionFtn': 
							await this.updateDataPost({ state: 'tablaPost', data: ['info_ingresos','afiliacion_registro','servicios_nuevos']})
						break; 
						case 'guardarFtn':		
							// resetea servicios_nuevos y asigna los check true de dataMultiple a servicios_nuevos					
								await this.resetDataForm({state: 'servicios_nuevos'}) 
								let servicios_nuevos = []

								for(let i=0;i<this.dataMultiple[this.namePath].multiple_servicios.length;i++)
								{
									if(this.dataMultiple[this.namePath].multiple_servicios[i].check===1 && this.dataMultiple[this.namePath].multiple_servicios[i].disabled===0)
									{	
										let servicioValue=this.deepCopy(this.dataMultiple[this.namePath].multiple_servicios[i])	
										servicioValue.id_datos_afiliado=this.dataForm[this.namePath].info_afiliacion.id_datos_afiliado
										servicioValue.id_info_afiliacion=this.dataForm[this.namePath].info_afiliacion.id
										servicioValue.id=null		
										servicios_nuevos.push(servicioValue)							
									}          
								}	
							
								await this.updateDataForm({state:  'servicios_nuevos', data: servicios_nuevos})	
							// actualize afiliacion_registro 
								await this.updateDataForm({state:'afiliacion_registro/fecha', data: this.fecha().fecha.minHoy})
								await this.updateDataForm({state:'afiliacion_registro/id_datos_razon', data: this.dataForm[this.namePath].info_afiliacion.id_datos_razon})
								await this.updateDataForm({state:'afiliacion_registro/id_datos_asesor', data: this.dataForm[this.namePath].info_afiliacion.id_datos_asesor})
								await this.updateDataForm({state:'afiliacion_registro/id_info_afiliacion', data: this.dataForm[this.namePath].info_afiliacion.id})
								await this.updateDataForm({state:'afiliacion_registro/id_datos_afiliado', data: this.dataForm[this.namePath].datos_afiliado.id})
								await this.updateDataForm({state:'afiliacion_registro/servicios', data: this.dataForm[this.namePath].servicios_nuevos})

							// configurar dataPost
								await this.updateDataPost({ state: 'route', data: 'save_all'})
								await this.updateDataPost({ state: 'tablaPost', data: ['info_ingresos','datos_afiliado','info_afiliacion','afiliacion_registro','servicios_nuevos']})
								await this.updateDataPost({ state: 'tablaDelete', data: []})

								if(event.save===false)
								{								
									await this.updateDataPost({ state: 'data', data: []})	
								}				
							
								// abrir modal de afiliacion al guardar
								if(event.save===false && this.dataIndex[this.namePath]===false)
								{
									await this.updateGlobal({state: 'openModal/modal',    data: 
									{ value: true, title: 'Registrar Afiliación', modal: 'Afiliacion' } })

									return true
								}

						break;	
					}
				}

				let dataSave = await this.save(event.save,savePost)

				window.open( this.url+'/api/pdf/registro?id='+dataSave.ids.info_ingresos.toString()+'&token='+this.token,'_blank')
				const await30 =  this.resetCrud({state: 'searchSw'})				
				const await31 =  this.resetDataIndex()
				const await32 =  this.resetGlobal({state: 'openModal'})
				const await33 =  this.resetDataForm()
				const await34 =  this.resetGlobal({state: 'saveConfig/capa'}) 
				await await30
				await await31
				await await32
				await await33
				await await34
			}
			catch{

			}			
		}		
	},
}
